(function() {
  'use strict';

  angular
    .module('modals.addLink', ['factories.utils'])
    .controller('AddLinkCtrl', AddLinkCtrl);

  AddLinkCtrl.$inject = ['$scope'];

  function AddLinkCtrl($scope) {

    $scope.viewData = {
      textToDisplay: '',
      linkUrl: ''
    };

    $scope.viewState = {
      disableSubmit: true,
      showUrlError: true
    };

    $scope.fieldChange = function() {
      $scope.viewState.showUrlError = !$scope.validateUrl($scope.viewData.linkUrl);
      if (!$scope.viewData.textToDisplay) $scope.viewData.textToDisplay = '';
      $scope.viewState.disableSubmit = $scope.viewData.textToDisplay.length < 1 || $scope.viewState.showUrlError;
    }

    $scope.validateUrl = function(url) {
      if (!url) url = '';
      return (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) && url.split('//')[1].length > 0;
    }

    $scope.submit = function() {
      $scope.$close({ success: true, data: $scope.viewData });
    };
  }
})();

